import { render, staticRenderFns } from "./AddRoute.vue?vue&type=template&id=6d0864f4&"
import script from "./AddRoute.vue?vue&type=script&lang=js&"
export * from "./AddRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports